import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { SHARED_IMPORTS } from 'src/app/shared/standalone-imports';
import { BUILD_INFO } from '../../../../environments/build-info';

@Component({
  selector: 'app-build-info',
  imports: [
    ...SHARED_IMPORTS,
    MatCardModule,
  ],
  templateUrl: './build_info.component.html',
  // styleUrl: './build_info.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildInfoComponent implements OnInit {
  private readonly http = inject(HttpClient);
  buildDate = BUILD_INFO.buildDate;
  
  ngOnInit(): void {
  }
}
